import React from 'react';
import {Link} from "react-router-dom";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Stack from 'react-bootstrap/Stack';

import RadioButton from 'components/formElements/RadioButton';
import MapAddressSelection from 'components/formElements/MapAddressSelection';

import iconFlachdach from 'assets/images/icon_roof_flachdach.png';
import iconPultdach from 'assets/images/icon_roof_pultdach.png';
import iconSatteldach from 'assets/images/icon_roof_satteldach.png';
import iconSonstiges from 'assets/images/icon_roof_sonstiges.png';
import BackgroundMaps from 'assets/images/background_maps.png';

const RoofType = () => {

    const mapBackgroundStyle = {
        background: `url(${BackgroundMaps}) no-repeat`,
        backgroundSize: 'cover'
    };

    return (
        <Row className="full-height">
            <Col className="">
                <div className="ContainerPaddingSmall">
                    <Stack gap={3}>
                        <h1>Ihr Dach</h1>
                        <Stack gap={3} direction="horizontal">
                            <RadioButton name="RoofType" label="Flachdach" image={iconFlachdach}/>
                            <RadioButton name="RoofType" label="Pultdach" image={iconPultdach}/>
                            <RadioButton name="RoofType" label="Satteldach" image={iconSatteldach}/>
                            <RadioButton name="RoofType" label="Sonstiges" image={iconSonstiges}/>
                        </Stack>
                    </Stack>
                    <Stack gap={3} direction="horizontal" className="mt-4 flex-column flex-md-row button-group align-items-start">
                        <Link className="order-1 order-md-0 btn-previous" to="/">
                            <Button className="" variant="outline-light">Zurück</Button>
                        </Link>
                        <Link className="order-0 order-md-1 btn-next" to="/RoofArea">
                            <Button variant="success">Weiter zum nächsten Schritt</Button>
                        </Link>
                    </Stack>
                </div>
            </Col>
            <Col className="backgroundMaps mapContainerWrapper" style={mapBackgroundStyle}>
                <MapAddressSelection />
            </Col>
        </Row>
    )
}

export default RoofType;